export default {
  "Drag and drop files here, or click to select the files to download.":
    "Sleep bestanden hierheen, of klik om de bestanden te selecteren die u wilt downloaden.",
  "Select files": "Selecteer bestand",
  "Maximum upload file size: 8MB.":
    "Maximale bestandsgrootte voor uploaden: 8MB.",
  "Add a logo": "Voeg een logo toe",
  "Apply a mask": "Breng een masker aan",
  "Apply a mask to your medias": "Breng een masker aan op je media",
  "Apply a logo to your medias": "Breng een logo aan op uw media",
  Apply: "Van toepassing zijn",
  Cancel: "Annuleren",
  "Mask informations": "Maskeer informatie",
  Title: "Titel",
  Description: "Omschrijving",
  "Uploaded at": "Geüpload op",
  "File type": "Bestandstype",
  "File size": "Bestandsgrootte",
  Dimensions: "Dimensies",
  "Select or import your mask": "Selecteer of importeer uw masker",
  "Select or import your logo": "Selecteer of importeer uw logo",
  "Select size": "Selecteer grootte",
  Small: "Klein",
  Medium: "Medium",
  Large: "Groot",
  "eXtra Large": "Extra groot",
  "Select position": "Selecteer positie"
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js